import { Link } from "react-router-dom";
import { MUM_TILES, MUM_HERO_LOGO } from "./assets";

const MAIN = ["tubers", "blooms", "flowers", "seeds"];
const SECONDARY = ["journal", "database", "gallery", "summary", "wishlist", "tasks"];

export default function MumsHome() {
  return (
    <div className="space-y-10" data-testid="mums-home">
      {/* Welcome */}
      <header className="text-center" data-testid="mums-home-header">
        <img
          src={MUM_HERO_LOGO}
          alt="Mum's Shed seal"
          className="w-44 h-44 sm:w-52 sm:h-52 mx-auto rounded-full ring-2 ring-[var(--mum-cornflower)] shadow-[0_24px_50px_-20px_rgba(15,27,60,0.55)] mum-shimmer"
        />
        <div className="mum-chip mx-auto mt-4">A Secret Garden Manager</div>
        <h1 className="font-display text-5xl mt-2 text-[var(--mum-sapphire)] leading-none">Welcome back, Mum</h1>
        <p className="font-display italic text-[var(--mum-cobalt)] mt-2">
          {new Date().toLocaleDateString(undefined, { dateStyle: "long" })}
        </p>
      </header>

      {/* MAIN 2x2 */}
      <section data-testid="mums-main-tiles">
        <div className="mum-divider mb-3">The Garden</div>
        <div className="grid grid-cols-2 gap-4 sm:gap-6">
          {MAIN.map((k) => <Tile key={k} k={k} large />)}
        </div>
      </section>

      {/* GARDEN BUILDER — featured between the two sections */}
      <section data-testid="mums-builder-tile">
        <div className="mum-divider mb-3">Plan The Patch</div>
        <div className="max-w-xl mx-auto">
          <Tile k="builder" />
        </div>
      </section>

      {/* SECONDARY 3 per row */}
      <section data-testid="mums-secondary-tiles">
        <div className="mum-divider mb-3">The Records</div>
        <div className="grid grid-cols-3 gap-3 sm:gap-4 max-w-3xl mx-auto">
          {SECONDARY.map((k) => <Tile key={k} k={k} small />)}
        </div>
      </section>
    </div>
  );
}

function Tile({ k, large, small }) {
  const tile = MUM_TILES[k];
  if (!tile) return null;
  if (!tile.src) {
    return (
      <Link
        to={tile.to}
        data-testid={`tile-${k}`}
        className={`mum-tile mum-tile-builder ${large ? "mum-tile-large" : ""} ${small ? "mum-tile-small" : ""}`}
        aria-label={tile.label}
      >
        <span className="mum-tile-builder-label">{tile.label}</span>
      </Link>
    );
  }
  return (
    <Link
      to={tile.to}
      data-testid={`tile-${k}`}
      className={`mum-tile group ${large ? "mum-tile-large" : ""} ${small ? "mum-tile-small" : ""}`}
      aria-label={tile.label}
    >
      <img src={tile.src} alt={tile.label} className="mum-tile-img" loading="lazy" />
      <span className="sr-only">{tile.label}</span>
    </Link>
  );
}
